import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiQuery } from '../../../../common/model/api.query';
import { JobOfferOutput } from '../model/job-offer.output';

export interface FetchJobOffersByOwnerIdAndOrganizationModuleIdParams {
	readonly organizationModuleId: string;
	readonly ownerId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchJobOffersByOwnerIdAndOrganizationModuleIdApiQuery extends ApiQuery<
	JobOfferOutput[],
	FetchJobOffersByOwnerIdAndOrganizationModuleIdParams
> {
	client = 'iam';
	document = gql`
		query FetchJobOffersByOwnerIdAndOrganizationModuleId(
			$ownerId: UUID!
			$organizationModuleId: UUID!
		) {
			fetchJobOffersByOwnerIdAndOrganizationModuleId(
				ownerId: $ownerId
				organizationModuleId: $organizationModuleId
			) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'fetchJobOffersByOwnerIdAndOrganizationModuleId';
}
